import React, { createContext, useContext, useEffect, useState } from 'react';
import { EventLogItem } from '../types/eventLogs';

export interface EventContextProps {
  eventLogProps: EventLogItem[];
  setEventLogProps: React.Dispatch<React.SetStateAction<EventLogItem[]>>;
}

export const EventContext = createContext<EventContextProps | null>(null);

export const EventProvider = ({ children }: { children: React.ReactNode }) => {
  const [eventLogProps, setEventLogProps] = useState<EventLogItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setEventLogProps([]);
    setLoading(false);
  }, []);

  if (loading) {
    return null;
  }
  return (
    <EventContext.Provider value={{ eventLogProps, setEventLogProps }}>
      {children}
    </EventContext.Provider>
  );
};

export function useEvent(): EventContextProps {
  const context = useContext(EventContext);
  return context || assertNever();
}

function assertNever(): never {
  throw Error('Cannot use useEvent outside of EventProvider');
}
